import { render } from "./NavUserMenu.vue?vue&type=template&id=731f4972&scoped=true"
import script from "./NavUserMenu.vue?vue&type=script&lang=js"
export * from "./NavUserMenu.vue?vue&type=script&lang=js"

import "./NavUserMenu.vue?vue&type=style&index=0&id=731f4972&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731f4972"]])

export default __exports__